import { render, staticRenderFns } from "./AddChequeMargin.vue?vue&type=template&id=0f627be9"
import script from "./AddChequeMargin.vue?vue&type=script&lang=js"
export * from "./AddChequeMargin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports